import { isObject } from '../isObject/isObject';
/**
 * Check if passed value is type of String.
 *
 * @param {unknown} value Value to check.
 * @returns {boolean}
 */
export function isString(value) {
    try {
        if (typeof value === 'string') {
            return true;
        }
        return isObject(value) && Object.prototype.toString.call(value) === '[object String]';
    }
    catch (e) {
        return false;
    }
}
